export interface BlacklistRecord {
    type: 0 | 1; // 0-拉黑 1-取消拉黑
    reason: string;
    timestamp: number;
}

export interface Seller {
    id: string;
    nickname: string;
    realName: string;
    phone: string;
    status: 'active' | 'deleted';
    isSuperIndividual: 0 | 1;
    requiredDeposit: number;
    actualDeposit: number;
    consultCount: number;
    dealCustomerCount: number;
    orderCount: number;
    netConversionRate: number;
    grossConversionRate: number;
    level: number;
    creditLevel: number;
    creditLevelDesc: string;
    wechat: string;
    douyin: string;
    isVerified: boolean;
    signatureImage: string;
    unwithdrawAmount: number;
    blacklistRecords: BlacklistRecord[];
    registerTime: number;
}

export const formatLevel = (level: number) => {
    return `Lv.${level}`;
}

export const formatConversionRate = (rate: number) => {
    return `${(rate * 100).toFixed(2)}%`;
}

export const formatMoney = (amount: number) => {
    return `¥${amount.toFixed(2)}`;
} 